import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 100%;
  height: 100%;
  background: ${(props) => props.theme.colors.widget_background};
  border-radius: 12px;
  overflow: hidden;
  position: relative;


  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 16px;
    cursor: default;
    }

  .devices-status-container {
    cursor: default;
    display: flex;
    flex: 1;
    min-height: 0;
    flex-direction: column;
    justify-content: center;
    gap: 16px;
  }

  .devices-status-container > div {
      padding: 0 !important;
    }
`;

export default { Wrapper };
